import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRotate } from '@fortawesome/free-solid-svg-icons';
import DefaultCPButton from './defaultCommandPanelButton';

function RefreshButton({ content, onClick, disabled }) {
  return (
    <DefaultCPButton
      content={content}
      onClick={onClick}
      disabled={disabled}
      icon={<FontAwesomeIcon icon={faArrowsRotate} />}
    />
  );
}

RefreshButton.propTypes = {
  content: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

RefreshButton.defaultProps = {
  content: 'Оновити',
  disabled: false,
};

export default RefreshButton;
